import { Link } from '@/components/ui/link';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import { usePage } from '@inertiajs/react';

export default function Navbar() {
  const {
    props: { auth },
  } = usePage();

  return (
    <div className="sticky top-0 flex w-full items-center gap-3 bg-white py-3 pl-3 pr-7 shadow">
      <SidebarTrigger className={cn(auth.user ? '' : 'invisible')} />
      <Link
        href={auth.user ? route('dashboard.index') : route('welcome')}
        className="flex items-center gap-3"
        noUnderline
      >
        <img src="/images/logo.png" alt="logo" className="max-h-[3rem]" />
        <p className="hidden text-3xl font-bold text-primary md:block">
          Goldtime5star
        </p>
      </Link>
    </div>
  );
}
